export default "__VITE_ASSET__3VKmUhJF__"